module.exports = __webpack_public_path__ + "static/004-a90dcb8fa6cbb56884500bf7369d9a9d.jpg";